import { MimeType } from '../components/constants/MimeType';

export const getDocumentUrl = async (mimeType: string, document: Blob): Promise<string> => {
    if (mimeType === MimeType.PDF) {
        const documentUrl: string = await URL.createObjectURL(document);
        return documentUrl;
    }
    return '';
};
